// extracted by mini-css-extract-plugin
export default {"specialFloorsContainer":"styles_specialFloorsContainer__VUQj8","rowTitles":"styles_rowTitles__6mq8Y","title":"styles_title__ZJ02I"};